import createCaseModal from "./CreateCaseModal";

export const CustomModal = {
  CreateCaseModal: createCaseModal,
};
